import React from 'react';
import Modal from "react-modal";
import "./SuccessModal.css";
import Lottie from "lottie-react";
import Complete from "../../../assets/lottie/Complete.json";
import Error from "../../../assets/lottie/Error.json";

const SuccessModal = (props) => {
    const { openSuccessModal, setOpenSuccessModal, successMessage, setSuccessMessage, recallFunctionOnOk, recallFunctionOnClose } = props;

   
    const closeModal = () => {
        setOpenSuccessModal(false);
        recallFunctionOnClose();
    }


    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    const style = {
        width: "34%",
        height: "120px",
        margin: "0 auto"
    }
    return (
        <div>
            <Modal
                isOpen={openSuccessModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="inner-success-modal">
                    <div className="close-btn" onClick={() => closeModal()}><span>X</span></div>
                    <div className="success-image">
                        <Lottie animationData={Complete} style={style} />
                    </div>
                    <div className="modal-message" >
                        {successMessage}
                    </div>
                    <div className="ok-btn">
                        <button onClick={() => { recallFunctionOnOk(); setOpenSuccessModal(false) }}>OK</button>
                    </div>
                </div>

            </Modal>
        </div>
    )
}

export default SuccessModal